import { type FC, type JSX } from 'react';

import { type Optional } from 'utility-types';

import TimerOutlined from '@mui/icons-material/TimerOutlined';

import { type FormatTimeSpentOptions, type PartialTimeSpent } from '@craft/lib/durations';
import { TrackedTime } from '@craft/ui/components/datetimes';

import { IconTextDisplay, type IconTextDisplayProps } from './IconTextDisplay';

export interface TrackedTimeDisplayProps extends Omit<
  Optional<IconTextDisplayProps, 'icon'>,
  'children'
> {
  readonly children?: [JSX.Element, JSX.Element];
  readonly options?: FormatTimeSpentOptions;
  readonly time?: PartialTimeSpent;
}

export const TrackedTimeDisplay: FC<TrackedTimeDisplayProps> = ({
  children,
  icon = TimerOutlined,
  iconSize = 16,
  options,
  time,
  typographyProps,
  ...props
}) => (
  <IconTextDisplay gap={1} {...props} icon={icon} iconSize={iconSize}>
    {children ? (
      <>
        {children[0]} / {children[1]}
      </>
    ) : (
      <TrackedTime inherit lineClamp={1} {...typographyProps} {...time} options={options} />
    )}
  </IconTextDisplay>
);
